import { useTranslation } from "react-i18next";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import useProductInfo from "src/mocks/useProductInfo";

const ProductFeatures = () => {
  const { cardInfo } = useProductInfo();
  const { isDspProduct } = useProductFlags();
  const { t } = useTranslation();
  // DSP 제품의 경우 하드코딩된 특성 개수를 사용
  const getDspFeatures = () => {
    const features = [];
    for (let i = 1; i <= 3; i++) {
      const featureText = t(`subscriptionType.terms.dsp.premium_${i}`);
      if (
        featureText &&
        featureText !== `subscriptionType.terms.dsp.premium_${i}`
      ) {
        features.push(featureText);
      }
    }
    return features;
  };

  // 표시할 특성 목록 결정
  const featuresToDisplay = isDspProduct
    ? getDspFeatures()
    : cardInfo?.features || [];

  return (
    <>
      {featuresToDisplay.map((item, index1) => (
        <div className="text text--lg mg mb-16 flex" key={index1}>
          <i className="icon_check_info_blue inline-block vertical-middle" />
          <span
            style={{ color: "#252D38", lineHeight: "22px" }}
            className="terms inline-block vertical-middle mg ml-10 text text--14 font-weight-400"
          >
            {item}
          </span>
        </div>
      ))}
      {/* 예전에 있던 기능 더보기 버튼 */}
      {/* {productInfo.featuresCnt > 3 && (
        <div className="text text--lg mg mb-16">
          <a className="cursor-pointer" onClick={() => toggleMoreInfo()}>
            <i
              className={`${
                toggleMoreInfoOn ? "icon_minus_green" : "icon_plus_green"
              } inline-block vertical-middle`}
            />
            <span className="inline-block vertical-middle mg ml-10 text text--green">
              {priceType &&
                priceType !== "" &&
                t(
                  "siteType." +
                    priceType +
                    ".orderSpecification." +
                    (toggleMoreInfoOn ? "hide" : "showMore")
                )}
            </span>
          </a>
        </div>
      )} */}
    </>
  );
};

export default ProductFeatures;
